import React, { useEffect, useState } from "react";
import ndispo from "../../../assets/media/img/n-dispo.jpg";
import useAuth from "../../../hooks/useAuth";
import axios from "../../../api/axios";
import { useNavigate, useLocation } from "react-router-dom";
const _URL = "/link/new";
const NewLink = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { auth } = useAuth();
  useEffect(() => {
    document.title = "Shorter | New";
  }, []);
  const from = location.state?.from?.pathname || "/links";
  const [url, setURL] = useState("");

  const [isValidURL, setIsValidURL] = useState(-1);
  const [title, setTitle] = useState();
  const [previewURL, setPreviewURL] = useState();
  const Nav = useNavigate();
  const handleURLChange = (event) => {
    const inputValue = event.target.value;
    setURL(inputValue);
    setIsValidURL(-1);
    setPreviewURL("");
  };
  const [imageUrl, setImageUrl] = useState();
  const handleImageError = (event) => {
    setImageUrl(ndispo);
  };
  useEffect(() => {
    setImageUrl(previewURL?.image);
  }, [previewURL]);
  const handleURLBlur = () => {
    setIsValidURL(isURL(url) && 1);
    if (isURL(url)) {
      const key = "4c2a6caf61bcc0d0ed1b0836fc6a2d11";
      var data = {
        key: key,
        q: url,
      };
      fetch("https://api.linkpreview.net", {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(data),
      })
        .then((res) => {
          if (res.status != 200) {
            throw new Error("something went wrong");
          }
          return res.json();
        })
        .then((response) => {
          setPreviewURL(response);
          setTitle(response.title);
        })
        .catch((error) => {});
    }
  };
  const isURL = (str) => {
    const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
    return urlPattern.test(str);
  };
  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };
  const createNewLink = () => {
    if (isValidURL != 1) {
      setIsValidURL(null);
      return;
    }
    handleSubmit();
  };
  const handleSubmit = async (e) => {
    try {
      const response = await axios.post(
        _URL,
        JSON.stringify({
          userId: auth.userId,
          original: url,
          title: title,
        }),
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      navigate(from, { replace: true });
    } catch (err) {}
  };
  return (
    <>
      <div className="py-30px md:30px px-20px">
        <div className="flex w-full">
          <div className="max-w-[600px] mx-auto w-full ">
            <h1 className="text-primary-900 dark:text-accent-200 text-2xl font-semibold mb-16px">
              New
            </h1>
            <div className="w-full flex flex-col gap-10px py-20px border-b border-accent-100 dark:border-accent-600">
              <label
                htmlFor="url"
                className={`text-accent-400 dark:text-accent-300 text-sm font-medium ${
                  isValidURL != null && isValidURL
                    ? ""
                    : "error-message text-red-400"
                } `}
              >
                Your long url{" "}
                {isValidURL != null && isValidURL ? "" : " is not valid"}
              </label>
              <input
                className={`w-full outline-none py-12px px-20px font-semibold rounded-lg shadow-sm border border-accent-100 dark:border-none dark:bg-accent-800 dark:placeholder:text-accent-400 text-accent-200 box-border focus-within:outline focus-within:outline-primary-500 focus-within:border-transparent ${
                  isValidURL != null && isValidURL
                    ? ""
                    : "input-error border border-red-500 outline-none box-border "
                } `}
                type="text"
                id="url"
                placeholder="https://example.com/yourlongurl"
                value={url}
                onChange={handleURLChange}
                onBlur={handleURLBlur}
              />
            </div>
            {previewURL && (
              <div className="w-full flex flex-col gap-10px py-20px border-b border-accent-100 dark:border-accent-600">
                <a
                  href={previewURL?.url}
                  className="flex gap-16px p-10px border border-accent-100 rounded-lg box-border bg-white"
                  title={previewURL?.url}
                >
                  <div className="flex max-w-[135px] rounded-sm overflow-hidden aspect-video">
                    <img
                      className="w-full object-cover"
                      src={imageUrl}
                      onError={handleImageError}
                      alt=""
                    />
                  </div>
                  <div className="flex text-sm gap-10px flex-col justify-between whitespace-nowrap overflow-hidden text-ellipsis">
                    <div className="lex flex-col text-sm gap-[2px]">
                      <p className="m-0 whitespace-nowrap max-w-[420px] overflow-hidden text-ellipsis font-semibold text-primary-800 text-sm">
                        {previewURL?.title}
                      </p>
                      <p className="m-0 whitespace-nowrap max-w-[420px] overflow-hidden text-ellipsis">
                        {previewURL?.description}
                      </p>
                    </div>
                    <p className="m-0 whitespace-nowrap max-w-[420px] overflow-hidden text-ellipsis underline text-sm text-primary-500">
                      {previewURL?.url}
                    </p>
                  </div>
                </a>
              </div>
            )}
            <div className="w-full flex flex-col gap-10px py-20px border-b border-accent-100 dark:border-accent-600">
              <label
                className="text-accent-400 dark:text-accent-300 text-sm font-medium"
                htmlFor="title"
              >
                Title (optional)
              </label>
              <input
                className="w-full outline-none py-12px px-20px font-semibold rounded-lg shadow-sm border border-accent-100 dark:border-none dark:bg-accent-800 dark:placeholder:text-accent-400 dark:placeholder: dark:text-accent-300 text-accent-200 box-border focus-within:outline focus-within:outline-primary-500  focus-within:border-transparent"
                type="text"
                id="title"
                placeholder="URL title"
                value={title}
                onChange={handleTitleChange}
              />
            </div>
            <div className="flex flex-row items-end gap-20px w-full py-20px border-b border-accent-100 dark:border-accent-600 h-fit">
              <div className="flex flex-col gap-10px w-full">
                <label
                  className="text-accent-400 dark:text-accent-300 text-sm font-medium"
                  htmlFor="domaine"
                >
                  Domain name
                </label>
                <input
                  className="w-full outline-none py-12px px-20px font-semibold rounded-lg shadow-sm border dark:text-accent-400 dark:bg-accent-800 border-accent-100 dark:border-accent-600 box-border focus-within:outline focus-within:outline-primary-500 focus-within:border-transparent"
                  type="text"
                  value="snil.ink"
                  id="domaine"
                  disabled
                />
              </div>
              <span className="mb-12px font-semibold text-primary-900 dark:text-accent-400">
                /
              </span>
              <div className="flex flex-col gap-10px w-full">
                <label
                  className="text-accent-400 dark:text-accent-300 text-sm font-medium"
                  htmlFor="path-name"
                >
                  Path name (optional)
                </label>
                <input
                  className="w-full outline-none py-12px px-20px font-semibold rounded-lg shadow-sm border dark:text-accent-400 dark:placeholder:text-accent-400 dark:bg-accent-800 border-accent-100 dark:border-accent-600 box-border focus-within:outline focus-within:outline-primary-500  focus-within:border-transparent"
                  type="text"
                  id="path-name"
                  placeholder="Comming soon"
                  disabled
                />
              </div>
            </div>
            {/* <div className="form-row toggle">
                <label htmlFor="">QR code (optional)</label>
                <div className="column">
                  <input type="checkbox" id="generate-qr-code" disabled />
                  <label className="label" htmlFor="generate-qr-code">
                    Toggle
                  </label>
                  <label htmlFor="generate-qr-code">
                    Generate a QR Code to share so people can scan it
                  </label>
                </div>
              </div> */}
            {/* <div className="form-row toggle">
                <label htmlFor="">Tracking analytics (optional)</label>
                <div className="column">
                  <input type="checkbox" id="track-analytics" />
                  <label className="label" htmlFor="track-analytics">
                    Toggle
                  </label>
                  <label htmlFor="track-analytics">
                    Track traffic analytics
                  </label>
                </div>
              </div> */}
            <div className="flex w-full pt-20px">
              <button
                className="w-full h-[44px] font-medium text-white text-sm outline-none border-none rounded-lg py-10px px-20px bg-primary-500 cursor-pointer duration-300 hover:opacity-90"
                onClick={createNewLink}
              >
                Shorten link{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default NewLink;
